const broadCast = {
    path: 'broadCast',
    component: resolve => require(['@/pages/admin/message/broadCast/index.vue'], resolve)
}

export default broadCast